// Platform-scoped announcements — visible to every tenant's desktop users.
//
// No read-only branch: reaching this console at all requires a platform-admin
// session, and `platform.announcements.write` is part of that role.

import type { AdminHttpClient } from '../../http.js';
import type { ToastMessage } from '../../types.js';
import { AnnouncementsManager } from '../announcements/AnnouncementsManager.js';

export function PlatformAnnouncementsTab({
  http,
  onToast,
  active,
}: {
  http: AdminHttpClient;
  onToast: (toast: ToastMessage) => void;
  active: boolean;
}) {
  return (
    <AnnouncementsManager
      http={http}
      scope="platform"
      canWrite
      onToast={onToast}
      active={active}
    />
  );
}
